export default __webpack_public_path__ + "static/media/DeleteWhiteIcon.32e112a3.svg";